export default __webpack_public_path__ + "static/media/icon-3.16af0378.svg";